export default function NotAllowedIpPage() {
  return (
    <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
      <h1>Access Denied</h1>
      <p>Your IP is not authorized to use this application.</p>
    </div>
  );
}
